import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { setStyles, getMargin, getHeight } from '../../utils/dom.js';

let intersectionObserver;
let resizeObserver;
function resetFixedStyles(el, config) {
  ['position', 'top', 'left', 'right', ...Object.keys(config.fixedStyles || {})].forEach(attr => {
    el.style.removeProperty(attr);
  });
  el.classList.remove('is-sticky');
  el.placeholderEl.style.display = el.style.display || 'inherit';
}
function syncStyles(el, config, rootContainer) {
  if (el.fixed) {
    const boundingClientRect = el.getBoundingClientRect();
    const rootBounds = rootContainer.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const fixedStyles = _objectSpread2({
      left: boundingClientRect.left,
      right: viewportWidth - boundingClientRect.right
    }, config.fixedStyles || {});
    if (config.fixedStyles && config.relativeToRoot) {
      if (config.fixedStyles.left != null) {
        fixedStyles.left = rootBounds.left - config.fixedStyles.left;
      }
      if (config.fixedStyles.right != null) {
        const distanceFromRight = viewportWidth - rootBounds.right;
        fixedStyles.right = distanceFromRight + config.fixedStyles.right;
      }
    }
    setStyles(el, fixedStyles);
  } else {
    setStyles(el.placeholderEl, _objectSpread2({
      minHeight: getHeight(el),
      height: getHeight(el)
    }, getMargin(el)));
  }
}
function setFixedStyles(entry, el, config) {
  const {
    rootBounds,
    boundingClientRect
  } = entry;
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const fixedStyles = _objectSpread2({
    position: 'fixed',
    top: rootBounds.top,
    left: boundingClientRect.left,
    right: viewportWidth - boundingClientRect.right
  }, config.fixedStyles || {});
  if (config.fixedStyles && config.relativeToRoot) {
    if (config.fixedStyles.left != null) {
      fixedStyles.left = rootBounds.left - config.fixedStyles.left;
    }
    if (config.fixedStyles.right != null) {
      const distanceFromRight = viewportWidth - rootBounds.right;
      fixedStyles.right = distanceFromRight + config.fixedStyles.right;
    }
  }
  el.classList.add('is-sticky');
  el.placeholderEl.style.display = 'block';
  setStyles(el, fixedStyles);
}
function getRootContainer(config) {
  return document.querySelector(config.root || '.pendo-page-container');
}
function initObservers(el, config) {
  const rootContainer = getRootContainer(config);
  const options = {
    root: rootContainer || null,
    rootMargin: `${parseInt(config.rootMargin) || 0}px`,
    threshold: [0, 1]
  };
  intersectionObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const sentinelInfo = entry.boundingClientRect;
      const rootInfo = entry.rootBounds;
      if (sentinelInfo.bottom < rootInfo.top) {
        el.fixed = true;
        setFixedStyles(entry, el, config);
      }
      if (sentinelInfo.bottom >= rootInfo.top && sentinelInfo.bottom < rootInfo.bottom) {
        el.fixed = false;
        resetFixedStyles(el, config);
      }
    });
  }, options);
  resizeObserver = new ResizeObserver(() => {
    syncStyles(el, config, rootContainer || document.body);
  });
  resizeObserver.observe(rootContainer || document.body);
  resizeObserver.observe(el);
  intersectionObserver.observe(el.sentinelEl);
}
function createPlaceholder(el) {
  const placeholder = document.createElement('div');
  setStyles(placeholder, _objectSpread2({
    display: 'inherit',
    position: 'relative',
    minHeight: getHeight(el),
    height: getHeight(el)
  }, getMargin(el)));
  return placeholder;
}
function createSentinel() {
  const sentinel = document.createElement('div');
  sentinel.classList.add('pendo-affix__sentinel');
  return sentinel;
}
function inserted(el, _ref, vnode) {
  let {
    value
  } = _ref;
  if (typeof value === 'undefined' || value) {
    vnode.context.$nextTick(() => {
      const placeholderEl = createPlaceholder(el);
      const sentinelEl = createSentinel();
      el.placeholderEl = placeholderEl;
      el.sentinelEl = sentinelEl;
      if (el.parentNode) {
        el.parentNode.insertBefore(placeholderEl, el);
      }
      placeholderEl.appendChild(sentinelEl);
      placeholderEl.appendChild(el);
      initObservers(el, value || {});
    });
  }
}
function componentUpdated(el, _ref2) {
  let {
    value
  } = _ref2;
  const config = value || {};
  const rootContainer = getRootContainer(config);
  syncStyles(el, config, rootContainer || document.body);
}
function unbind(el, _ref3) {
  let {
    value
  } = _ref3;
  intersectionObserver.unobserve(el.sentinelEl);
  intersectionObserver.disconnect();
  resizeObserver.disconnect();
  resetFixedStyles(el, value || {});
  el.sentinelEl = undefined;
  el.placeholderEl = undefined;
  el.fixed = undefined;
}
const PendoAffix = {
  inserted,
  componentUpdated,
  unbind
};
var PendoAffix$1 = PendoAffix;

export { PendoAffix, createPlaceholder, createSentinel, PendoAffix$1 as default, initObservers, resetFixedStyles, setFixedStyles, syncStyles };
//# sourceMappingURL=pendo-affix.js.map
